/* eslint-disable import/prefer-default-export */
import * as yup from "yup";
import ImageAttachmentId from "lib/files/images/imageAttachments";

export const firstName = yup.string().trim().label("First Name").required();
export const lastName = yup.string().trim().label("Last Name").required();
export const email = yup
  .string()
  .trim()
  .label("Email Address")
  .required()
  .email();

export const profileImageId = yup
  .string()
  .test(
    "processed-image",
    "Wait for the profile photo to finish uploading and processing.",
    (value) => value !== ImageAttachmentId.PROCESSING,
  )
  .uuid()
  .nullable()
  .defined()
  .label("Profile Photo");
